import { render, staticRenderFns } from "./AnnotationGrid.vue?vue&type=template&id=d00e08f4&scoped=true"
import script from "./AnnotationGrid.vue?vue&type=script&lang=js"
export * from "./AnnotationGrid.vue?vue&type=script&lang=js"
import style0 from "./AnnotationGrid.vue?vue&type=style&index=0&id=d00e08f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00e08f4",
  null
  
)

export default component.exports